// extracted by mini-css-extract-plugin
export const titleSection = "article-module--titleSection--Iw6OC";
export const titleSectionSide = "article-module--titleSectionSide--uqBwW";
export const title = "article-module--title--1Ua8G";
export const credits = "article-module--credits--3YTsZ";
export const featuredImage = "article-module--featuredImage--3SALr";
export const content = "article-module--content--35sZg";
export const returnLink = "article-module--returnLink--2vb7L";